import { Routes } from '@angular/router';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { AppRoleKey } from '@nk/data-entities-lib';
import { SCREENING_CASE_REVIEW_ROUTE } from '../utils/screening-case-review.utils';

export const COMPANY_SCREENING_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../components/company-screening/company-screening.component').then((m) => m.CompanyScreeningComponent),
    data: {
      title: extractTranslation('tabs.company.screening') as string,
      faicon: 'binoculars',
      feature: 'screening',
      roles: [AppRoleKey.aml],
    },
  },
  {
    path: SCREENING_CASE_REVIEW_ROUTE,
    loadComponent: () =>
      import('../components/screening-case-review/screening-case-review.component').then(
        (m) => m.ScreeningCaseReviewComponent,
      ),
    data: {
      noTab: true,
      title: extractTranslation('screening.case.review.case_review'),
      navigationOnFormComplete: 'screening-company-view',
      entityType: 'company',
    },
  },
  {
    path: ':screeningEntityUuid/screening-cases',
    loadComponent: () =>
      import('../components/company-screening-cases/company-screening-cases.component').then(
        (m) => m.CompanyScreeningCasesComponent,
      ),
    data: {
      title: extractTranslation('screening.tabs.company.screening_cases'),
      noTab: true,
    },
  },
];
